//#region src/client/storage-key.ts
const ldFlagStorageKey = "overriddenLDflags";

//#endregion
export { ldFlagStorageKey };